import { createORPCClient } from '@orpc/client'
import { RPCLink } from '@orpc/client/fetch'
import type { ContractRouterClient } from '@orpc/contract'
import { createTanstackQueryUtils } from '@orpc/tanstack-query'
import type { Contract } from '@snitch/contract'
import { getBearerToken } from './auth.ts'

// Same origin: Vite proxies /api in development, Caddy in production. The session cookie is
// first-party; the Mini App adds its bearer token instead.
const link = new RPCLink({
  url: () => `${window.location.origin}/api/rpc`,
  headers: () => {
    const token = getBearerToken()
    return token ? { authorization: `Bearer ${token}` } : {}
  },
})

export const api: ContractRouterClient<Contract> = createORPCClient(link)

/** Query/mutation option factories: `useQuery(orpc.pricing.catalog.queryOptions())`. */
export const orpc = createTanstackQueryUtils(api)
